import yachtEquipmentPacksApiService from '@/services/api/YachtEquipmentPacks'

const INSTALLED_BY_SHIPYARD = 'shipyard'
const INSTALLED_BY_NAVIGARE = 'navigare'
const INSTALLED_BY_CONTRACTOR = 'contractor'

const STATUS_DRAFT = 'draft'
const STATUS_ACTIVE = 'active'
const STATUS_DISCARDED = 'discarded'

const emptyItem = {
  label: null,
  code: null,
  quantity: 1,
  unit_purchase_price: null,
  unit_sale_price: null,
  purchase_price: null,
  sale_price: null
}
const emptyFilters = {
  label: null,
  yacht_model_id: null,
  country_id: null,
  supplier_id: null,
  yacht_equipment_pack_category_id: null,
  type: null,
  status: null
}
const emptyModel = {
  label: null,
  items: [
    emptyItem
  ],
  code: null,
  currency: 'EUR',
  installed_by: null,
  supplier_id: null,
  yacht_equipment_pack_category_id: null,
  is_configurable: false,
  purchase_price: null,
  sale_price: null,
  note: null,
  offer_visible: true,
  offer_visible_sale_price: false,
  offer_items_visible: true,
  offer_items_visible_sale_price: false,
  models: [],
  countries: []
}
const installedByData = {
  [INSTALLED_BY_SHIPYARD]: {
    label: 'Shipyard',
    key: INSTALLED_BY_SHIPYARD
  },
  [INSTALLED_BY_CONTRACTOR]: {
    label: 'Commissioning Yard',
    key: INSTALLED_BY_CONTRACTOR
  },
  [INSTALLED_BY_NAVIGARE]: {
    label: 'Base (Custom)',
    key: INSTALLED_BY_NAVIGARE
  }
}

const statusData = {
  [STATUS_DRAFT]: {
    color: 'grey darken-1',
    label: 'Draft',
    dark: true,
    key: STATUS_DRAFT
  },
  [STATUS_ACTIVE]: {
    color: 'primary',
    label: 'Available',
    key: STATUS_ACTIVE
  },
  [STATUS_DISCARDED]: {
    color: 'grey lighten-1',
    label: 'Discarded',
    key: STATUS_DISCARDED
  }
}

class YachtEquipmentPack {
  constructor() {
    this.api = yachtEquipmentPacksApiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters
    this.emptyItem = emptyItem

    this.INSTALLED_BY_SHIPYARD = INSTALLED_BY_SHIPYARD
    this.INSTALLED_BY_NAVIGARE = INSTALLED_BY_NAVIGARE
    this.INSTALLED_BY_CONTRACTOR = INSTALLED_BY_CONTRACTOR
    this.installedByData = installedByData
    this.statusData = statusData

    this.STATUS_DRAFT = STATUS_DRAFT
    this.STATUS_ACTIVE = STATUS_ACTIVE
    this.STATUS_DISCARDED = STATUS_DISCARDED
  }
}

const yachtEquipmentPack = new YachtEquipmentPack()

export default yachtEquipmentPack
